module.exports = __webpack_public_path__ + "img/skull.992bf01c.png";